const Services = () => {
  const services = [
    {
      title: "AI Agent Development",
      description: "Custom AI agents tailored to your specific business needs and workflows.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="4" fill="white"/>
            <circle cx="6" cy="6" r="1.5" fill="white"/>
            <circle cx="18" cy="6" r="1.5" fill="white"/>
            <circle cx="18" cy="18" r="1.5" fill="white"/>
            <circle cx="6" cy="18" r="1.5" fill="white"/>
            <line x1="12" y1="12" x2="6" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="12" y1="12" x2="18" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="12" y1="12" x2="18" y2="18" stroke="white" strokeWidth="1"/>
            <line x1="12" y1="12" x2="6" y2="18" stroke="white" strokeWidth="1"/>
          </svg>
        </div>
      ),
      features: ["Custom AI Models", "Workflow Integration", "Real-time Learning", "24/7 Monitoring"]
    },
    {
      title: "Process Automation",
      description: "Automate complex business processes with intelligent decision-making capabilities.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="10" width="4" height="4" fill="white" rx="1"/>
            <rect x="10" y="6" width="4" height="4" fill="white" rx="1"/>
            <rect x="18" y="10" width="4" height="4" fill="white" rx="1"/>
            <rect x="10" y="14" width="4" height="4" fill="white" rx="1"/>
            <path d="M6 12L10 8M14 8L18 12M18 12L14 16M14 16L10 16" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
      ),
      features: ["Workflow Automation", "Decision Trees", "Exception Handling", "Performance Analytics"]
    },
    {
      title: "Data Intelligence",
      description: "Transform raw data into actionable insights with AI-powered analysis.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="16" width="2" height="6" fill="white" rx="0.5"/>
            <rect x="8" y="12" width="2" height="10" fill="white" rx="0.5"/>
            <rect x="12" y="8" width="2" height="14" fill="white" rx="0.5"/>
            <rect x="16" y="10" width="2" height="12" fill="white" rx="0.5"/>
            <path d="M5 16L9 12L13 8L17 10" stroke="white" strokeWidth="1" strokeLinecap="round"/>
            <circle cx="5" cy="16" r="1" fill="white"/>
            <circle cx="9" cy="12" r="1" fill="white"/>
            <circle cx="13" cy="8" r="1" fill="white"/>
            <circle cx="17" cy="10" r="1" fill="white"/>
          </svg>
        </div>
      ),
      features: ["Predictive Analytics", "Pattern Recognition", "Real-time Processing", "Custom Dashboards"]
    },
    {
      title: "Integration Services",
      description: "Seamlessly integrate AI agents with your existing systems and platforms.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="8" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <rect x="16" y="8" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <rect x="9" y="2" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <rect x="9" y="18" width="6" height="4" fill="none" stroke="white" strokeWidth="1" rx="1"/>
            <line x1="8" y1="10" x2="12" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="16" y1="10" x2="12" y2="6" stroke="white" strokeWidth="1"/>
            <line x1="8" y1="10" x2="12" y2="18" stroke="white" strokeWidth="1"/>
            <line x1="16" y1="10" x2="12" y2="18" stroke="white" strokeWidth="1"/>
            <circle cx="12" cy="12" r="2" fill="white"/>
          </svg>
        </div>
      ),
      features: ["API Integration", "Database Connectivity", "Third-party Tools", "Legacy System Support"]
    },
    {
      title: "Consulting & Strategy",
      description: "Expert guidance on AI implementation and digital transformation strategies.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="3" fill="white"/>
            <path d="M12 2V6M12 18V22M22 12H18M6 12H2" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M19.07 4.93L16.24 7.76M7.76 16.24L4.93 19.07M19.07 19.07L16.24 16.24M7.76 7.76L4.93 4.93" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
      ),
      features: ["Strategic Planning", "Technology Assessment", "ROI Analysis", "Implementation Roadmap"]
    },
    {
      title: "Training & Support",
      description: "Comprehensive training and ongoing support for your AI systems.",
      icon: (
        <div className="w-12 h-12 bg-[#212331] rounded-lg flex items-center justify-center">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="12" fill="none" stroke="white" strokeWidth="2" rx="2"/>
            <path d="M7 8L10 11L17 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="20" r="2" fill="white"/>
            <path d="M8 20H16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
      ),
      features: ["Team Training", "Documentation", "24/7 Support", "Regular Updates"]
    }
  ]

  return (
    <section id="Services" className="section services py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our{' '}
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Services
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We help businesses transform their operations with cutting-edge AI agent technology, 
            delivering measurable results and sustainable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div 
              key={index}
              className="service-card bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Service Icon */}
              <div className="mb-6 flex justify-center lg:justify-start">{service.icon}</div>
              
              {/* Service Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              {/* Service Description */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              {/* Service Features */}
              <div className="features-list">
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                      <div className="w-4 h-4 bg-[#212331] rounded mr-3 flex items-center justify-center flex-shrink-0">
                        <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 1L3.5 6.5L1 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Learn More Button */}
              <div className="mt-6">
                <a 
                  href="/solutions" 
                  className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold transition-colors"
                >
                  Learn More
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-8 rounded-2xl text-white">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4">
              Ready to Transform Your Business?
            </h3>
            <p className="text-xl mb-6 text-blue-100">
              Let's discuss how AI agents can revolutionize your operations.
            </p>
            <a 
              href="/contact" 
              className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            >
              Start Your AI Journey
              <svg className="w-5 h-5 ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14m-7-7l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services
